/**
 * @file FlashList atom — high-performance list primitive.
 * @description Structured atom: parts re-exported from the third-party
 * Shopify FlashList package; the only sanctioned import path for app code
 * (RFC §3).
 *
 * NativeWind class props do NOT work on this atom. `className`,
 * `contentContainerClassName` and the other `*ClassName` props are silently
 * ignored: NativeWind only rewrites them for components registered with
 * `cssInterop`/`remapProps`, and `react-native-css-interop`'s
 * `runtime/components.ts` registers `ScrollView`, `FlatList` and
 * `VirtualizedList` — never `@shopify/flash-list`. Nothing in this repository
 * registers it either, so the class string is handed straight to FlashList,
 * which does not read it, and no lint rule or type error reports the loss.
 *
 * Measured on staging web (SE-6281): an invitations list declaring
 * `contentContainerClassName="flex-grow p-3 self-center pb-4"` computed
 * `align-self: auto`, `flex-grow: 0`, `padding: 0px` on its content container,
 * while `contentContainerStyle` was honoured in the same render. Express
 * FlashList layout through `style` / `contentContainerStyle`, not through a
 * class name. Several call sites across the app still carry inert `*ClassName`
 * props; turning them all on at once is a deliberate, reviewable change rather
 * than something to do in passing.
 * @module components/atoms/FlashList
 */
export { FlashList } from "@shopify/flash-list";
export type {
  FlashListProps,
  FlashListRef,
  ListRenderItem,
} from "@shopify/flash-list";
